import React from 'react'
import classes from './styles.module.scss'
// import { FormattedMessage } from 'react-intl'
// import messages from './messages'
// import { Icon } from 'antd-mobile'

export default class MapMarker extends React.Component {
  // constructor(props) {
  //   super(props)
  //   this.state = {
  //     foo: 'foo'
  //   }
  // }

  handleClick = () => {
    const { form, lat, lng, data } = this.props
    form.setFieldsValue({
      selectedMerchant: `${lat},${lng}`,
      selectedMerchantInfo: data,
    })
  }

  render() {
    const { data, selectedMerchant, lat, lng } = this.props
    const isSelected = selectedMerchant === `${lat},${lng}`
    return (
      <div className={classes.componentsMapMarker} onClick={this.handleClick}>
        <img
          width={isSelected ? 36 : 24}
          src={isSelected ? data.activeIcon : data.defaultIcon}
        />
        {isSelected && <span>{data.merchantName || data.name}</span>}
      </div>
    )
  }
}
